import { List } from 'immutable';
import { UserFactory, EnhancedUserFactory } from 'domain/organizationUser/helpers';
import { currentCompanyIdSelector, isDocumentConfidentialSelector } from 'domain/documents/documentSelector';
import { selector } from 'lib/selectors';

export const organizationUsersSelector = (state) => state.organizationUser;

export const organizationUsersForConfidentialDocSelector = selector(
  (state) => state.chat.users,
  isDocumentConfidentialSelector,

  (users, isDocumentConfidential) =>
    !isDocumentConfidential
      ? users.filter(({ role }) => role !== 'supplier')
      : users.filter(
          (user) =>
            [
              'confidential-user',
              'confidential-restricted-user',
              'accountant',
              'limited-accountant',
              'restricted-accountant',
            ].includes(user.role), // user role have access to confidentialdocs
        ),
);

export const getOrganizationUserByIdSelector = (id) => (state) => state.organizationUser.find((_) => _.id === id);

// finds bookkeeper by id or returns empty bookkeeper
export const organizationUserByIdSelector = (id) => (state) =>
  state.organizationUser.find((_) => _.id === id) || UserFactory();

export const organizationEnhancedUsersSelector = selector(
  organizationUsersSelector,
  currentCompanyIdSelector,
  (users, companyId) =>
    List(
      users.map((user) => {
        // pure 'Record -> another Record' transform, find a way to do it better
        const enhancedUser = {
          ...user.toObject(),
          assigned: user.companies_id.has(companyId),
          assignedCount: user.companies_id.size,
        };

        return EnhancedUserFactory(enhancedUser);
      }),
    ),
);

export const isRequiredAccountantsSelector = selector(
  organizationUsersSelector,
  currentCompanyIdSelector,
  (users, companyId) => {
    const accountants = users.filter(
      (user) =>
        ['accountant', 'limited-accountant', 'restricted-accountant'].includes(user.role) &&
        user.companies_id.includes(companyId),
    );

    return !accountants.size;
  },
);
